module.exports = require('./lib/jsurl');